// src/hooks/NovuProvider.tsx
import { Novu } from "@novu/js";
import { buildSubscriber } from "@novu/js/internal";
import { createContext, useContext, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
var NovuContext = createContext({ novu: void 0, realtime: true });
var NovuProvider = (props) => {
  const { subscriberId, realtime = true, ...propsWithoutSubscriberId } = props;
  const subscriberObj = useMemo(
    () => buildSubscriber({ subscriberId, subscriber: props.subscriber }),
    [subscriberId, props.subscriber]
  );
  const applicationIdentifier = propsWithoutSubscriberId.applicationIdentifier ? propsWithoutSubscriberId.applicationIdentifier : "";
  const providerProps = {
    ...propsWithoutSubscriberId,
    applicationIdentifier,
    subscriber: subscriberObj,
    realtime
  };
  return /* @__PURE__ */ jsx(InternalNovuProvider, { ...providerProps, applicationIdentifier, children: props.children });
};
var InternalNovuProvider = (props) => {
  const applicationIdentifier = props.applicationIdentifier || "";
  const subscriberObj = useMemo(
    () => buildSubscriber({ subscriberId: props.subscriberId, subscriber: props.subscriber }),
    [props.subscriberId, props.subscriber]
  );
  const {
    children,
    subscriberHash,
    contextHash,
    backendUrl,
    apiUrl,
    socketUrl,
    socketOptions,
    useCache,
    defaultSchedule,
    context,
    realtime = true
  } = props;
  const value = useMemo(
    () => ({
      novu: new Novu({
        applicationIdentifier,
        subscriberHash,
        contextHash,
        backendUrl,
        apiUrl,
        socketUrl,
        socketOptions,
        useCache,
        subscriber: subscriberObj,
        defaultSchedule,
        context
      }),
      realtime
    }),
    [
      applicationIdentifier,
      subscriberHash,
      subscriberObj,
      context,
      contextHash,
      backendUrl,
      apiUrl,
      socketUrl,
      socketOptions,
      useCache,
      realtime
    ]
  );
  return /* @__PURE__ */ jsx(NovuContext.Provider, { value, children });
};
var useNovu = () => {
  const context = useContext(NovuContext);
  if (!context.novu) {
    throw new Error("useNovu must be used within a <NovuProvider />");
  }
  return context.novu;
};
var useUnsafeNovu = () => {
  const context = useContext(NovuContext);
  return context.novu;
};
var useRealtime = () => {
  const context = useContext(NovuContext);
  return context.realtime;
};
export {
  InternalNovuProvider,
  NovuProvider,
  useNovu,
  useRealtime,
  useUnsafeNovu
};
//# sourceMappingURL=NovuProvider.js.map